import React, { useRef } from 'react';
import styles from './SwiperCustom.module.scss';
import { Swiper } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { sanitizeType } from '../../functions';

const SwiperCustom = ({
  children,
  spaceBetween,
  type,
  // animationData,
  slidesPerView = 1.5,
  className = '',
  breakpoints = {
    390: {
      slidesPerView: 1.3,
    },
    640: {
      slidesPerView: 2.2,
    },
    992: {
      slidesPerView: 3.2,
    },
    1400: {
      slidesPerView: 4.2,
    },
    2100: {
      slidesPerView: 5.2,
    },
  },
  isSocialMedia = false,
}) => {
  const swiperButtonPrevRef = useRef(null);
  const swiperButtonNextRef = useRef(null);
  const prevButtonClassName = isSocialMedia ? `${styles.swiperButtonPrevSocial} ` : styles.swiperButtonPrev;
  const nextButtonClassName = isSocialMedia ? `${styles.swiperButtonNextSocial} ` : styles.swiperButtonNext;
  return (
    <Swiper
      scrollbar={{
        el: '.swiper-scrollbar',
        hide: false,
        draggable: true,
        dragClass: 'swiper-scrollbar-drag',
      }}
      navigation={{ prevEl: swiperButtonPrevRef.current, nextEl: swiperButtonNextRef.current }}
      onBeforeInit={(swiper) => {
        swiper.params.navigation.prevEl = swiperButtonPrevRef.current;
        swiper.params.navigation.nextEl = swiperButtonNextRef.current;
      }}
      slidesPerView={slidesPerView}
      spaceBetween={16}
      breakpoints={breakpoints}
      modules={[Navigation, Scrollbar]}
      className={`${styles.swiperCards} ${className} ${sanitizeType(type, styles)}`}
    >
      {children}
      <div className={`${styles.swiperScrollbar}  swiper-scrollbar swiper-scrollbar-custom ${sanitizeType(type, styles)}`}></div>
      <div ref={swiperButtonPrevRef} className={prevButtonClassName + ' swiper-button-prev'}></div>
      <div ref={swiperButtonNextRef} className={nextButtonClassName + ' swiper-button-next'}></div>
    </Swiper>
  );
};

export default SwiperCustom;
